var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{style:(_vm.styleVariables)},[_c('AppHeader',{attrs:{"common":_vm.common,"data":_vm.data}}),_c('router-view',{attrs:{"common":_vm.common}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }